export default __webpack_public_path__ + "static/media/black-diamond.7e6a1e96.jpg";